import React, { useState, useRef } from "react";
import { Flex, Stack, Heading, Text, Link, Box, Button } from "@chakra-ui/react";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import CustomFormInput from "../components/FormInputFields";
import CommonVars from "../components/CommonVars";

function LoginScreen() {
    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    return (
        <Formik
            initialValues={{
                username: '',
                password: '',
            }}
            validationSchema={Yup.object({
                username: Yup.string()
                .min(4, 'Username must be at least 4 characters long')
                .required('Username is required'),
                password: Yup.string()
                .min(4, 'Password is too short - should be 4 characters minimum.')
                .required('Password is required'),
            })}
            onSubmit = {(values, { setSubmitting, resetForm }) => {
                const loginRequestBody = values;
                axios.post(`${CommonVars.API_URL}/login`, loginRequestBody)
                .then((response) => {
                    // retrieve the jwt and userDetails from the response data
                    const { token } = response.data;
                    const { userDetails } = response.data;
                    // store the login details in localStorage
                    localStorage.setItem('token', token);
                    localStorage.setItem('userDetails', JSON.stringify(userDetails));
                    setSuccessMsg('Successfully logged in!');
                    resetForm();
                    setSubmitting(false);
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 1800)
                })
                .catch((error) => {
                    // if to check for 401 status code
                    if (error.response?.status === 401) {
                        setErrMsg('Incorrect username or password.');
                        setTimeout(() => {
                            setErrMsg();
                            console.clear();
                        }, 3000)
                    }
                    setSubmitting(false);
                })
            }}
        >
            {props => (
                <Flex 
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                    <Stack align={'center'}>
                        <Heading fontSize={'4xl'}>Login to your account</Heading>
                        <Text fontSize={'lg'} color={'gray.600'}>
                            Don't have an account? <Link color={'blue.400'} href='/sign-up'>Sign Up</Link>
                        </Text>
                    </Stack>
                    <Box
                        rounded={'lg'}
                        bg={'white'}
                        boxShadow={'lg'}
                        p={8}
                    >
                        <Form>
                            <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p>
                            <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
                            <Stack spacing={4}>
                                {/* Username Input */}
                                <CustomFormInput
                                    label="Username" 
                                    name="username" 
                                    type="text"
                                    placeholder="Enter Username"
                                />
                                {/* Password Input */}
                                <CustomFormInput
                                    label="Password" 
                                    name="password" 
                                    type="password"
                                    placeholder="Enter Password"
                                />
                                <Link pb={3} color={'#37404A'} href="/forgot-password">Forgot password?</Link>
                                <Button
                                    type="submit"
                                    bg={'black'}
                                    color={'white'}
                                    _hover={{
                                    bg: '#37404A',
                                    }}
                                >
                                    {props.isSubmitting ? 'Logging in...' : 'Login'}
                                </Button>
                            </Stack>
                        </Form>
                    </Box>
                </Stack>
            </Flex>
            )}
        </Formik>
    )
}

export default LoginScreen;